// src/UserCreation.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const UserCreation = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('user'); // 'user' ou 'admin'
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const authToken = localStorage.getItem('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      const response = await axios.post(
        '/api/members',
        { username, password, email, role },
        {
          headers: { Authorization: `Bearer ${authToken}` }
        }
      );
      setMessage(`Compte créé : ${response.data.username}`);
      setUsername('');
      setPassword('');
      setEmail('');
      setRole('user');
      // Redirection après 2 secondes
      setTimeout(() => navigate('/user-management'), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la création du compte');
    }
  };

  return (
    <div className="container">
      <div className="mb-3">
        <Link to="/user-management" className="btn btn-secondary">
          ← Retour à la gestion des utilisateurs
        </Link>
      </div>
      <h2>Création de compte utilisateur</h2>
      {message && <div className="alert alert-success">{message}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Nom d'utilisateur</label>
          <input
            type="text"
            className="form-control"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Mot de passe</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Rôle</label>
          <select className="form-select" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="user">Utilisateur</option>
            <option value="admin">Administrateur</option>
          </select>
        </div>
        <button type="submit" className="btn btn-primary">
          Créer le compte
        </button>
      </form>
    </div>
  );
};

export default UserCreation;